import React, { useEffect, useRef, useState, FunctionComponent } from 'react';

interface ImageBlenderProps {
  src: string;
  alt?: string;
  limitWidth?: number;
}

const ImageBlur: FunctionComponent<ImageBlenderProps> = ({ src, alt, limitWidth }) => {
  const [backgroundColor, setBackgroundColor] = useState('lightblue');
  const imageRef = useRef<HTMLImageElement | null>(null);

  const getAverageColor = (image: HTMLImageElement) => {
    const width = image.width;
    const height = image.height;

    const canvas = document.createElement('canvas');

    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext('2d');

    if (ctx) {
      ctx.drawImage(image, 0, 0, width, height);

      if (width > height) {
        const pixelData = ctx.getImageData(width / 2, height - 1, 1, 1).data;
        return `rgb(${pixelData[0]}, ${pixelData[1]}, ${pixelData[2]})`;
      } else if (height > width) {
        const pixelData = ctx.getImageData(width - 1, height / 2, 1, 1).data;
        return `rgb(${pixelData[0]}, ${pixelData[1]}, ${pixelData[2]})`;
      }
    }
    console.error('Unable to determine average border color, defaulting to lightblue', image)
    return 'lightblue'
  }


  return (
    <div
      style={{
        width: limitWidth ? `${limitWidth}px` : '100%',
        paddingBottom: limitWidth ? `${limitWidth}px` : '100%',
        background: backgroundColor,
        position: 'relative',
        overflow: 'hidden',
      }}
      className='rounded'
    >
      <img ref={imageRef} src={src} alt={alt}
        onLoad={e => {
          setBackgroundColor(getAverageColor(e.currentTarget))
        }}

        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }} className='rounded' />
    </div>
  );
};

export default ImageBlur;